module.exports = __webpack_public_path__ + "img/Ultrajhakaas_Square _logo_red.e2279cdb.jpg";